"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetOlapicData = void 0;
var _presentationUtils = require("@ori/presentation-utils");
var _react = require("react");
var _contexts = require("../contexts");
var _utils = require("../utils");
var _useGetMedia = require("./useGetMedia");
var _useGetOlapicCategory = require("./useGetOlapicCategory");
var _useGetOlapicInfo = require("./useGetOlapicInfo");
var _useGetOlapicStream = require("./useGetOlapicStream");
var _useGetShareItem = require("./useGetShareItem");
var _utils2 = require("./utils");
/* istanbul ignore file -- api */

const useGetOlapicData = ({
  apiKey = '',
  type
}) => {
  const {
    categoryId,
    productCode
  } = (0, _contexts.useConfiguration)();
  // window.location.hash is not available in the test environment of storybook as it is rendered in an iframe
  const shareItemId = (0, _react.useMemo)(() => (0, _presentationUtils.isSSR)() ? undefined : (0, _utils.getQueryHash)(process.env.NODE_ENV === 'development' ? window.parent.location.hash : window.location.hash), []);
  const tag = (0, _utils2.getTag)({
    type,
    categoryId,
    productCode
  });
  const {
    data: {
      customerId
    } = {},
    isError: isErrorInfo
  } = (0, _useGetOlapicInfo.useGetOlapicInfo)({
    apiKey
  });
  const {
    data: {
      category
    } = {},
    isError: isErrorCategory
  } = (0, _useGetOlapicCategory.useGetOlapicCategory)({
    apiKey,
    customerId: customerId ?? '',
    tag,
    enabled: Boolean(type === 'Category' && categoryId)
  });
  const {
    data: {
      stream
    } = {},
    isError: isErrorStream
  } = (0, _useGetOlapicStream.useGetOlapicStream)({
    apiKey,
    customerId: customerId ?? '',
    tag,
    enabled: Boolean(type === 'ProductDetails' && productCode)
  });
  const {
    data: media,
    isLoading,
    isError: isErrorMedia
  } = (0, _useGetMedia.useGetMedia)({
    apiKey,
    type,
    categoryId: category?.id,
    customerId,
    streamId: stream?.id
  });
  const {
    data: shareItem,
    isLoading: isLoadingShareItem
  } = (0, _useGetShareItem.useGetShareItem)({
    apiKey,
    items: media?.mediaItems ?? [],
    shareItemId
  });
  const isError = isErrorInfo || isErrorCategory || isErrorStream || isErrorMedia;
  const response = (0, _react.useMemo)(() => {
    if (shareItemId) {
      return {
        media: {
          mediaItems: shareItem && media ? [shareItem, ...media.mediaItems] : [],
          loadMoreUrl: media?.loadMoreUrl
        },
        loaded: Boolean(!isLoading && !isError && media && shareItem),
        shareItemId,
        isLoading: isLoading || isLoadingShareItem,
        isError
      };
    }
    return {
      media,
      loaded: Boolean(!isLoading && !isError && media),
      shareItemId,
      isLoading,
      isError
    };
  }, [shareItemId, media, isLoading, isError, shareItem, isLoadingShareItem]);
  return response;
};
exports.useGetOlapicData = useGetOlapicData;
